import React, { useContext } from "react";
import { Select, Card, Col, Row, DatePicker, Empty } from "antd";
import { statusList } from "../../utils";
import { ChartMonthComparative } from "./components/Sale/ChartMonthComparative";
import { ChartCategory } from "./components/Sale/ChartCategory";
import { ChartStatus } from "./components/Sale/ChartStatus";
import { ManagementType } from "./components/Sale/ManagementType";
import { ChartComparativeBrand } from "./components/Sale/ChartComparativeBrand";
import { OrdersContext } from "../../context/OrdersContext";

const { Option } = Select;
const { RangePicker } = DatePicker;

const dateFormat = "DD-MM-YYYY";

const statusOptions = statusList ? Object.keys(statusList) : [];

const BoardSaleTree = () => {
  const { 
    filteredOrdersByStart,
    dataOrders, 
    statusFilter,
    dateFilter, 
    isLoadingSales,
    isLoadingOrders,
    isLoadingDateFilteredData,
    setStatusFilter,
    setDateFilter, } = useContext(OrdersContext);

  const isLoading =
    isLoadingSales || isLoadingOrders || isLoadingDateFilteredData;

  if (isLoading) {
    return (
      <div style={{ marginTop: 40, marginLeft: 20 }}>Cargando ventas...</div>
    );
  } else {
    return (
      <div className="flex justify-center h-fit">
        <div className="grid-rows-custom grid-cols-custom gap-x-0 gap-y-0 m-5 w-full xl:w-11/12">
          <div>
            <div
            className="flex justify-end pb-4"
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <div className="mr-5 w-80">
                <RangePicker
                  value={dateFilter}
                  onChange={(dates) => setDateFilter(dates)}
                  format={dateFormat}
                />
              </div>
              <div>
                <Select
                  mode="multiple"
                  value={
                    statusFilter?.length ? statusFilter : ["Todos los estados"]
                  }
                  onChange={(value) => {
                    if (
                      value.includes("Todos los estados") &&
                      statusFilter.length === 1
                    ) {
                      setStatusFilter(["Todos los estados"]);
                    } else {
                      setStatusFilter(
                        value.filter((item) => item !== "Todos los estados")
                      );
                    }
                  }}
                  style={{ minWidth: 200 }}
                >
                  <Option disabled value="Todos los estados">
                    Todos los estados
                  </Option>
                  {statusOptions?.map((option) => (
                    <Option key={option} value={option}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="py-4 h-fit">
            {filteredOrdersByStart?.length > 0 ? (
              <ChartComparativeBrand data={filteredOrdersByStart} />
            ) : (
              <Card title="Comparativa de Ventas por Marca">
                <div
                className="h-80 flex justify-center items-center"
                >
                  <Empty description="No hay datos disponibles" />
                </div>
              </Card>
            )}
          </div>
          <div className="">
          <Row className="flex flex-col lg:flex-row" gutter={16}>
          <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={16}>
                {filteredOrdersByStart?.length > 0 ? (
                  <ChartStatus data={filteredOrdersByStart} />
                ) : (
                  <Card title="Estados">
                    <div
                    className="h-80 flex justify-center items-center"
                    >
                      <Empty description="No hay datos disponibles" />
                    </div>
                  </Card>
                )}
              </Col>
              <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={8}>
                {filteredOrdersByStart?.length > 0 ? (
                  <ManagementType data={filteredOrdersByStart} />
                ) : (
                  <Card title="Gestión">
                    <div
                    className="h-80 flex justify-center items-center"
                    >
                      <Empty description="No hay datos disponibles" />
                    </div>
                  </Card>
                )}
              </Col>
            </Row>
          </div>
          <div className="">
          <Row className="flex flex-col lg:flex-row" gutter={16}>
            <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={12}>
                {filteredOrdersByStart?.length > 0 ? (
                  <ChartCategory data={filteredOrdersByStart} />
                ) : (
                  <Card title="Categorias">
                    <div
                    className="h-80 flex justify-center items-center">
                      <Empty description="No hay datos disponibles" />
                    </div>
                  </Card>
                )}
              </Col>
              <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={12}>
                <ChartMonthComparative data={dataOrders} />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
};

export default BoardSaleTree;
